import { color } from '@nuvolo/nuux-theme/utils';
import { TextArea } from 'devextreme-react/text-area';
import styled from 'styled-components';

const SimpleTextArea = styled(TextArea)`
  width: 100%;

  &.dx-texteditor {
    border-radius: 16px !important;
    background-color: ${color('custom', 'formInputBackground')} !important;
  }

  &.dx-texteditor.dx-editor-outlined.dx-state-hover,
  &.dx-texteditor.dx-editor-outlined.dx-state-focused {
    box-shadow: inset 0 0 0 1px ${color('ui', 'dark')} !important;
  }

  .dx-texteditor-input {
    padding: 12px 16px;
    min-height: 80px;
    color: ${color('primary', 'dark')};
  }
`;

export default SimpleTextArea;
